// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__gZ2KV","text":"style_text__BibFB","main":"style_main__6rJwc","secondary":"style_secondary__Aj3VQ","contactUs":"style_contactUs__QV5Md"};